// extracted by mini-css-extract-plugin
export var timeline_item = "timeline-module--timeline_item--1Sxl1";
export var date = "timeline-module--date--s0Dm8";
export var item = "timeline-module--item--3iDDo";
export var tutorialCard = "timeline-module--tutorialCard--3Lduw";